import INVENTORY_API_BASE_URL from "../../config/api";
import  { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import "./CreatePayment.css";
import swal from "sweetalert";

const CreatePayment = () => {
  const [data, setData] = useState([]);
  

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getVendor`).then((response) => {
      const reversedData = response.data.reverse();
      setData(reversedData);
    });
  }, []);

  const handleUpdate = async (id, paid, date) => {
    if (!paid || !date) {
      swal({
        icon: "error",
        title: "Invoice Amount and Date can't be left blank",
      });
      return;
    }
    try {
      await Axios.put(`${INVENTORY_API_BASE_URL}/PaymentUpdates/${id}`, {
        PaymentUpdates: [{ Paid: paid, PaymentDate: date }],
      });
    } catch (error) {
      console.error("Error updating payment:", error);
    }
    swal({
      icon: "success",
      title: "Payment Updated Successfully",
      timer: 1500, 
    });
    window.location.reload();
  };

  return (
    <div>
      <h6 className="paymrec">
        <h3 id="payHead">Create Payment Records(Shivalik)</h3>
      </h6>
      <Table className="payshiwalikh">
        <thead>
          <tr>
            <th>Invoice No.</th>
            <th>Invoice Amount</th>
            <th>Amount Paid</th>
            <th>Payment Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={row._id}>
              <td>{row.invoiceno}</td>

              <td>{row.Totalamount.toFixed(2)}</td>
              <td>
                <input type="number" name="paym" required/>
              </td>
              <td>
                <input type="date" name="paym_date" required/>
              </td>
              <td>
                <button
                  onClick={() =>
                    handleUpdate(
                      row._id,
                      parseFloat(
                        document.getElementsByName("paym")[index].value
                      ),
                      document.getElementsByName("paym_date")[index].value
                    )
                  }
                >
                  Update
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default CreatePayment;
